var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPopoverIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 69,
  viewBox: "0 0 80 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 56,
  stroke: "transparent"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1340_68889)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1340_68889)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 56,
  fill: "white",
  style: {
    mixBlendMode: "color-dodge"
  }
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1340_68889",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 16,
  y: 56,
  width: 47,
  height: 13
}, /*#__PURE__*/React.createElement("foreignObject", {
  x: -50,
  y: -50,
  width: 180,
  height: 156
}, /*#__PURE__*/React.createElement("div", {
  xmlns: "http://www.w3.org/1999/xhtml",
  style: {
    backdropFilter: "blur(65px)",
    clipPath: "url(#bgblur_2_1340_68889_clip_path)",
    height: "100%",
    width: "100%"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-figma-bg-blur-radius": 130,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 56.0032C17.7125 56.0032 19.4245 55.9947 21.137 56.0132C22.776 56.0312 24.6104 56.0567 26.2055 56.6582C27.9284 57.3083 29.0691 58.4448 30.2168 59.7823C31.043 60.7443 32.666 62.7969 33.4563 63.7879C34.1031 64.6004 35.3692 66.2064 36.0605 66.9835C36.9308 67.961 38.0064 69 39.5005 69C40.9946 69 42.0697 67.961 42.9395 66.9845C43.6308 66.2079 44.8969 64.6009 45.5442 63.7889C46.3335 62.7979 47.9565 60.7453 48.7832 59.7833C49.9329 58.4458 51.0716 57.3093 52.794 56.6592C54.3896 56.0592 56.2245 56.0322 57.8625 56.0142C59.5755 55.9957 61.2875 56.0042 63 56.0042",
  fill: "#FF0000"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1340_68889)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3_1340_68889)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 47,
  height: 13,
  transform: "translate(16 56)",
  fill: "white"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bgblur_2_1340_68889_clip_path",
  transform: "translate(50 50)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 56.0032C17.7125 56.0032 19.4245 55.9947 21.137 56.0132C22.776 56.0312 24.6104 56.0567 26.2055 56.6582C27.9284 57.3083 29.0691 58.4448 30.2168 59.7823C31.043 60.7443 32.666 62.7969 33.4563 63.7879C34.1031 64.6004 35.3692 66.2064 36.0605 66.9835C36.9308 67.961 38.0064 69 39.5005 69C40.9946 69 42.0697 67.961 42.9395 66.9845C43.6308 66.2079 44.8969 64.6009 45.5442 63.7889C46.3335 62.7979 47.9565 60.7453 48.7832 59.7833C49.9329 58.4458 51.0716 57.3093 52.794 56.6592C54.3896 56.0592 56.2245 56.0322 57.8625 56.0142C59.5755 55.9957 61.2875 56.0042 63 56.0042"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1340_68889"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 56,
  rx: 13,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1340_68889"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 56,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3_1340_68889"
}, /*#__PURE__*/React.createElement("rect", {
  width: 47,
  height: 13,
  fill: "white",
  transform: "translate(16 56)"
})))));
export default SvgPopoverIcon;